export function companyHasTournamentModule(companyExtraModules) {
  return (companyExtraModules || []).some(
    (m) => String(m.extra_module?.name || '').toLowerCase() === 'tournament'
  );
}

export function isTournamentCampaign(campaign, companyExtraModules) {
  const modRow = companyExtraModules?.find((m) => m.id === campaign?.company_extra_module_id);
  return (
    campaign?.type === 'EXTRA' &&
    campaign?.company_extra_module_id &&
    String(modRow?.extra_module?.name || '').toLowerCase() === 'tournament'
  );
}

/** Matches api/tournament_scoring.is_knockout_game */
export function isKnockoutGame(game) {
  if (!game || typeof game !== 'object') return false;
  if (game.knockout === true) return true;
  for (const key of ['predictionType', 'prediction_type', 'matchType', 'match_type']) {
    const raw = game[key];
    if (typeof raw === 'string' && ['knockout', 'winner'].includes(raw.toLowerCase())) return true;
  }
  const stage = game.stage;
  if (typeof stage === 'string' && stage.toLowerCase().includes('knockout')) return true;
  return false;
}
